import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { AddBankAccountFormComponent } from '@payments/components/add-bank-account-modal/add-bank-account-form/add-bank-account-form.component';
import { AddBankAccountModalComponent } from '@payments/components/add-bank-account-modal/add-bank-account-modal.component';
import { AgreementCheckboxComponent } from '@payments/components/add-bank-account-modal/agreement-checkbox/agreement-checkbox.component';
import { AutopayEffectiveDateComponent } from '@payments/components/add-bank-account-modal/autopay-effective-date/autopay-effective-date.component';
import { AutopayStepsComponent } from '@payments/components/add-bank-account-modal/autopay-steps/autopay-steps.component';
import { BankAccountListComponent } from '@payments/components/add-bank-account-modal/bank-account-list/bank-account-list.component';
import { CheckReferencePopoverComponent } from '@payments/components/add-bank-account-modal/check-reference-popover/check-reference-popover.component';
import { CheckReferenceTabTouchComponent } from '@payments/components/add-bank-account-modal/check-reference-tab-touch/check-reference-tab-touch.component';
import { ConfirmAutopayDetailsComponent } from '@payments/components/add-bank-account-modal/confirm-autopay-details/confirm-autopay-details.component';
import { SegmentsBankAccountComponent } from '@payments/components/add-bank-account-modal/segments-bank-account/segments-bank-account.component';
import { SetUpAutopayComponent } from '@payments/components/add-bank-account-modal/set-up-autopay/set-up-autopay.component';
import { CustomerSummarySectionComponent } from '@payments/components/customer-summary-section/customer-summary-section.component';
import { PaymentDetailsModalComponent } from '@payments/components/payment-details-modal/payment-details-modal.component';
import { SharedModule } from '@shared/shared.module';
import { CaretIconComponent } from './caret-icon/caret-icon.component';
import { EditPaymentAmountInputComponent } from './edit-payment-amount-input/edit-payment-amount-input.component';
import { EmptyStatesComponent } from './empty-states/empty-states.component';
import { HeaderFiltersComponent } from './header-filters/header-filters.component';
import { InvoiceDownloadModalComponent } from './invoice-download-modal/invoice-download-modal.component';
import { PaymentRowDesktopComponent } from './payment-row/desktop/payment-row-desktop.component';
import { PaymentRowMobileComponent } from './payment-row/mobile/payment-row-mobile.component';
import { PaymentRowTabletComponent } from './payment-row/tablet/payment-row-tablet.component';
import { PaymentsBasePage } from './payments-base/payments-base.page';
import { RowCardsTouchComponent } from './row-cards-touch/row-cards-touch.component';
import { SelectionBannerComponent } from './selection-banner/selection-banner.component';
import { TableHeaderComponent } from './table-header/table-header.component';
import { TopButtonComponent } from './top-button/top-button.component';
import { TransactionRowDesktopComponent } from './transaction-row/desktop/transaction-row-desktop.component';
import { TransactionRowTouchComponent } from './transaction-row/touch/transaction-row-touch.component';

@NgModule({
  declarations: [
    InvoiceDownloadModalComponent,
    SelectionBannerComponent,
    TransactionRowDesktopComponent,
    CustomerSummarySectionComponent,
    PaymentsBasePage,
    TopButtonComponent,
    EditPaymentAmountInputComponent,
    PaymentDetailsModalComponent,
    PaymentRowDesktopComponent,
    PaymentRowTabletComponent,
    PaymentRowMobileComponent,
    HeaderFiltersComponent,
    CaretIconComponent,
    TableHeaderComponent,
    AddBankAccountModalComponent,
    CheckReferencePopoverComponent,
    CheckReferenceTabTouchComponent,
    AddBankAccountFormComponent,
    AutopayStepsComponent,
    BankAccountListComponent,
    AgreementCheckboxComponent,
    ConfirmAutopayDetailsComponent,
    SetUpAutopayComponent,
    SegmentsBankAccountComponent,
    AutopayEffectiveDateComponent,
    EmptyStatesComponent,
    RowCardsTouchComponent,
    TransactionRowTouchComponent,
  ],
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatDatepickerModule,
    SharedModule,
  ],
  exports: [
    InvoiceDownloadModalComponent,
    SelectionBannerComponent,
    TransactionRowDesktopComponent,
    CustomerSummarySectionComponent,
    PaymentsBasePage,
    TopButtonComponent,
    EditPaymentAmountInputComponent,
    PaymentDetailsModalComponent,
    PaymentRowDesktopComponent,
    PaymentRowTabletComponent,
    PaymentRowMobileComponent,
    HeaderFiltersComponent,
    CaretIconComponent,
    TableHeaderComponent,
    AddBankAccountModalComponent,
    CheckReferencePopoverComponent,
    CheckReferenceTabTouchComponent,
    AddBankAccountFormComponent,
    AutopayStepsComponent,
    BankAccountListComponent,
    AgreementCheckboxComponent,
    ConfirmAutopayDetailsComponent,
    SetUpAutopayComponent,
    SegmentsBankAccountComponent,
    AutopayEffectiveDateComponent,
    EmptyStatesComponent,
    RowCardsTouchComponent,
    TransactionRowTouchComponent,
  ],
  providers: [DatePipe, CurrencyPipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PaymentsSharedModule {}
